import store from "@redux/store";
import { COUNTRY, COUNTRY_CONFIG } from "@type/index";

// true -> inch, false -> cm
// CA,PH -> inch
export const footAndInches: COUNTRY_CONFIG<boolean> = {
  [COUNTRY.AU]: false,
  [COUNTRY.CA]: true,
  [COUNTRY.ID]: false,
  [COUNTRY.IN]: false,
  [COUNTRY.MY]: false,
  [COUNTRY.PH]: true,
  [COUNTRY.SG]: false,
  [COUNTRY.TH]: false,
  [COUNTRY.VN]: false
};

// inch conversion
export const heightFootFromTotalInch = (totalInch: number) =>
  Math.floor(totalInch / 12);
export const heightInchFromTotalInch = (totalInch: number) =>
  Math.floor(totalInch % 12);
export const heightFootInchFromTotalInch = (totalInch: number) => {
  const foot = heightFootFromTotalInch(totalInch);
  const inch = heightInchFromTotalInch(totalInch);
  return `${foot}′ ${inch}″`;
};

export const userHeight = (height: number): string => {
  const config = store.getState().config;
  const country = config.region as COUNTRY;
  if (footAndInches[country])
    return height === 0 ? "-′-″" : heightFootInchFromTotalInch(height);
  else return height === 0 ? "-" : height?.toString() ?? "-";
};
